import PropTypes from 'prop-types';
import React from 'react'
import { WORK_FLOW_LOCATION_ACCOUNT, WORK_FLOW_MASTER_ACCOUNT } from './const';

const ScreenContext = React.createContext();

const screensToRefresh = new Set([
  WORK_FLOW_MASTER_ACCOUNT.ACTIVE_MAIN_SUBSCRIPTION,
  WORK_FLOW_MASTER_ACCOUNT.MASTER_ACCOUNT_SUBSCRIPTION,
  WORK_FLOW_LOCATION_ACCOUNT.ACTIVE_LOCATION_SUBSCRIPTION,
  WORK_FLOW_LOCATION_ACCOUNT.LOCATION_ACCOUNT_SUBSCRIPTION
]);

export const ScreenProviderSubscription = ({ initialScreen, parentScreen = null, children, triggerRefresh, user, profile }) => {
  const initialStack = parentScreen ? [parentScreen, initialScreen] : [initialScreen];
  const [screen, setScreen] = React.useState(initialScreen);
  const [screenStack, setScreenStack] = React.useState(initialStack);
  const [subscriptionProduct, setSubscriptionProduct] = React.useState(null);
  const [childAccount, setChildAccount] = React.useState(null);
  const [customerSubInfo, setCustomerSubInfo] = React.useState(null);
  const [selectedSubscription, setSelectedSubscription] = React.useState(null);
  const [selectedCard, setSelectedCard] = React.useState(null);
  const initialCtxMode = (typeof window !== 'undefined' && window.localStorage.getItem('subscription_selected_mode_ctx')) === 'location' ? 'location' : 'master';
  const [subscriptionSelectedMode, setSubscriptionSelectedMode] = React.useState(initialCtxMode);
  const initialCtxChild = typeof window !== 'undefined' ? (window.localStorage.getItem('subscription_selected_child_ctx') || '') : '';
  const [subscriptionSelectedChildId, setSubscriptionSelectedChildId] = React.useState(initialCtxChild);
  React.useEffect(() => {
    if (typeof window !== 'undefined') {
      window.localStorage.setItem('subscription_selected_mode_ctx', subscriptionSelectedMode);
    }
  }, [subscriptionSelectedMode]);

  React.useEffect(() => {
    if (typeof window !== 'undefined') {
      window.localStorage.setItem('subscription_selected_child_ctx', subscriptionSelectedChildId || '');
    }
  }, [subscriptionSelectedChildId]);


  const navigateTo = (newScreen) => {
    setScreenStack(prevStack => [...prevStack, newScreen]);
    setScreen(newScreen);
  };

  const goBack = () => {
    setScreenStack(prevStack => {
      if (prevStack.length > 1) {
        const newStack = prevStack.slice(0, -1);
        const newScreen = newStack[newStack.length - 1];

        if (screensToRefresh.has(newScreen)) triggerRefresh();

        setScreen(newScreen);
        return newStack;
      }
      return prevStack;
    });
  };
  

  return (
    <ScreenContext.Provider value={{
      selectedCard,
      setSelectedCard,
      customerSubInfo, 
      setCustomerSubInfo,
      screen, 
      setScreen, 
      subscriptionProduct,
      setSubscriptionProduct,
      childAccount, 
      setChildAccount,
      screenStack, 
      setScreenStack,
      selectedSubscription, 
      setSelectedSubscription,
      goBack,
      navigateTo,
      triggerRefresh,
      subscriptionSelectedMode,
      setSubscriptionSelectedMode,
      subscriptionSelectedChildId,
      setSubscriptionSelectedChildId,
      user,
      profile
    }}>
      {children}
    </ScreenContext.Provider>
  );
};
  
export const useScreenSubscription = () => React.useContext(ScreenContext);

ScreenProviderSubscription.propTypes = {
  initialScreen: PropTypes.string.isRequired,
  parentScreen: PropTypes.string,
  children: PropTypes.node.isRequired,
  triggerRefresh: PropTypes.func.isRequired,
  user: PropTypes.object,
  profile: PropTypes.object
};